var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"clip_ico",on:{"click":function($event){return _vm.pickFile()}}}),_c('input',{ref:'pic_file_'+_vm.invoice_id,staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.xls,.xlsx,.docx,.txt,.csv"},on:{"change":function($event){return _vm.onFilePicked($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }